import {NOTIFICATION_TYPES} from '@/features/notifications/notifications-constants';
import {ANALYTICS_SOURCE_TYPES} from '@/services/analytics/constants';
import {createNotification} from '@/features/notifications/utils/notification-utils';

export const createErrorNotification = (appError, t) => {
  if (!appError?.i18nKey) {
    return createNotification(
      NOTIFICATION_TYPES.DANGER,
      t('errors.generic.error_title'),
      t('errors.generic.error_message'),
    );
  }

  return createNotification(
    NOTIFICATION_TYPES.DANGER,
    t(`${appError.i18nKey}_title`),
    t(`${appError.i18nKey}_message`),
  );
};

export const getAnalyticsSourceType = (error) => {
  return error?.status
    ? ANALYTICS_SOURCE_TYPES.FETCH_BASE_QUERY_ERROR
    : ANALYTICS_SOURCE_TYPES.ERROR;
};
